import { isAndroid } from 'src/utils/platform';
import './SafeArea.css';
import { CSSProperties, FunctionComponent } from 'react';
import { twMerge } from 'src/utils/twMerge';

type Props = {
  className?: string;
  style?: CSSProperties;
};

const SafeAreaTop: FunctionComponent<Props> = ({ className, style }) => {
  return (
    <div
      style={style}
      className={twMerge(
        'safe-area safe-area-position-top',
        isAndroid()
          ? 'safe-area-android'
          : 'safe-area-ios',
        className,
      )}
    />
  );
};

export default SafeAreaTop;
